import { addDays } from 'date-fns'

export const defaultStay = {
	defaultStayPeriod: {
		checkIn: new Date(Date.now()),
		checkOut: addDays(new Date(Date.now()), 7)
	}
}
